<script setup lang="ts">
// index
import View from '~/pages-components/agent/index.vue'
</script>

<template>
  <ClientOnly>
    <View />
  </ClientOnly>
</template>

<style scoped lang="scss">

</style>
